import { memo } from 'react';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { defaultHeaderRenderer } from '../headers';
import { RightAlign } from '../styles';
import { IColumn } from '../types';

const RightAlignFormatter = memo(function formatter(cellProps: CellProps) {
  return (
    <CellEventsHandler cellProps={cellProps}>
      <RightAlign>{cellProps.row.agentDocumentComplete || ''}</RightAlign>
    </CellEventsHandler>
  );
});

export const AgentDocsColumn = (): IColumn => ({
  item: {
    key: 'agentDocumentComplete',
    name: 'Agent docs',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(104px, .75fr)',
    formatter: RightAlignFormatter,
  },
  visible: ({ isAgentDocsCountVisible, hasAgentOnlyDocs, isAgentUser }) =>
    !!isAgentDocsCountVisible && (!!hasAgentOnlyDocs || !!isAgentUser),
});
